<template>
    <div>
        <Head title="Find and Appointment" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">Find and Appointment</h3>
                    <p class="mt-2 text-base leading-7 text-slate-600">Select user to set schedule.</p>
                </div><!--end grid-->
            </div><!--end container-->

        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-0 text-white dark:text-slate-800">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Terms & Conditions -->
        <section class="relative md:py-24 py-16 bg-white dark:bg-slate-800">
            <div class="container">
                <div class="grid lg:grid-cols-12 grid-cols-1" id="reserve-form">
                    <div class="lg:col-start-2 lg:col-span-10">
                        <div class="bg-white dark:bg-slate-900 border-0 shadow dark:shadow-gray-800 rounded p-3 -mt-[150px]">
                            <form action="#">
                                <div class="appointment-search text-dark text-start">
                                    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-0 gap-6">
                                        <div class="filter-search-form relative filter-border">
                                            <icon name="" />
                                            <input name="search" type="text" id="people-keyword" class="form-input filter-input-box bg-gray-50 dark:bg-slate-800 rounded-none" placeholder="Search people">
                                        </div>

                                        <div class="filter-search-form relative filter-border">
                                            <i class="uil uil-map-marker icons"></i>
                                            <select v-model="form.profession" class="bg-gray-50 dark:bg-slate-800 form-select rounded-none" data-trigger name="profession" id="selectProfession" aria-label="Select profession">
                                                <option value="">Select profession</option>
                                                <option v-for="(profession, pi) in $page.props.professions" :key="pi" :value="profession.slug">{{ profession.name }}</option>
                                            </select>
                                        </div>

                                        <div class="filter-search-form relative filter-border">
                                            <i class="uil uil-briefcase-alt icons"></i>
                                            <select v-model="form.duration" class="bg-gray-50 dark:bg-slate-800 form-select rounded-none" data-trigger name="duration" id="timeSlot" aria-label="Time Slot">
                                                <option value="">Select duration</option>
                                                <option v-for="(duration, di) in durations" :key="di" :value="duration.value">{{ duration.name }}</option>
                                            </select>
                                        </div>

                                        <input type="submit" id="search" style="height: 60px;" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white searchbtn cursor-pointer submit-btn w-100" value="Search">
                                    </div><!--end grid-->
                                </div><!--end container-->
                            </form>
                        </div>
                    </div><!--ed col-->
                </div><!--grid-->
            </div><!--end container-->
            <div class="container">
                <div class="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[30px]">
                    <!-- Start Candidate Content -->
                    <div v-for="user in users.data" :key="user.id" class="group relative p-6 rounded-md shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 transition duration-500 text-center">
                        <!-- team p-6 rounded-md shadow-md dark:shadow-gray-800 dark:border-gray-700 bg-white dark:bg-slate-900 relative -->
                        <div class="absolute inset-0 bg-red-600/10 dark:bg-indigo-600/30 rounded-md -mt-[20px] ltr:-ml-[20px] rtl:-mr-[20px] h-[98%] w-[98%] -z-1"></div>
                        <div class="mt-8 mb-3">
                            <img v-if="user.photo_path" :src="user.photo_path" class="rounded-full shadow-md h-20 w-20 mx-auto block" alt="">
                            <img v-else src="/images/svg/profile.svg" class="rounded-full shadow-md h-20 w-20 mx-auto block" alt="">
                            <div class="mt-3">
                                <a :href="route('schedule.user', user.username)" class="text-lg font-medium hover:text-indigo-600 transition duration-500 block">{{ user.first_name }} {{ user.last_name }}</a>
                                <span class="block text-sm text-slate-400">{{ user.profession }}</span>
                            </div>
                        </div>

<!--                        <div class="flex items-center justify-around my-4">-->
<!--                            <span class="text-slate-400"><i class="uil uil-map-marker text-indigo-600 ltr:mr-1 rtl:ml-1"></i>London</span>-->
<!--                            <span class="text-slate-400"><i class="uil uil-dollar-sign text-indigo-600 ltr:mr-1 rtl:ml-1"></i>3300/mo</span>-->
<!--                        </div>-->


                        <a v-if="user.event_types.length" v-for="event_type in user.event_types" :href="route('schedule.user', user.username)" class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">{{ event_type.duration.replace('_', ' ') }}</a>
                        <span v-else class="bg-gray-100 dark:bg-gray-800 text-slate-400 text-xs font-medium px-3 py-1 rounded-lg h-[24px] inline-block m-1">no schedule option</span>
                        <p class="text-slate-400 mt-4" v-html="user.details.substr(0, 65)+'...'"></p>
                        <div class="mt-4">
                            <a :href="route('schedule.user', user.username)" class="btn bg-indigo-600/5 hover:bg-indigo-600 border-indigo-600/10 hover:border-indigo-600 text-indigo-600 hover:text-white rounded-md w-full">View Schedule Page</a>
                        </div>
                    </div>
                </div>

                <pagination class="mt-6" :links="users.links" />

            </div><!--end container-->
        </section><!--end section-->
<!--        <section class="relative md:py-20 py-16">-->
<!--            <div class="container">-->
<!--                <div class="md:flex justify-center">-->
<!--                    <div class="md:w-full">-->
<!--                        <div class="p-6 bg-white rounded-md leading-7 html" v-html="sanitizeHtml(page.content)">-->


<!--                        </div>-->
<!--                    </div>&lt;!&ndash;end &ndash;&gt;-->
<!--                </div>&lt;!&ndash;end grid&ndash;&gt;-->
<!--            </div>&lt;!&ndash;end container&ndash;&gt;-->
<!--        </section>&lt;!&ndash;end section&ndash;&gt;-->
        <!-- End Terms & Conditions -->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Landing/Pagination'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
export default {
    layout: Layout,
    components: {
        Icon,
        Pagination,
        Head
    },
    props: {
        users: Object,
        filters: Object,
    },
    data() {
        return {
            durations: [
                {value: '15_min', name: '15 Minutes'},
                {value: '30_min', name: '30 Minutes'},
                {value: '45_min', name: '45 Minutes'},
                {value: '60_min', name: '60 Minutes'},
                {value: '2_hrs', name: '2 Hours'},
            ],
            form: {
                profession: this.filters.profession ?? '',
                duration: this.filters.duration ?? '',
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('appointment'), pickBy(this.form), { replace: true, preserveState: true })
            }, 150),
        },
    },
    methods: {
        sanitizeHtml : sanitizeHtml
    },
    created() {
      console.log(this.filters)
    }
}
</script>
